var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAasLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f6961d;}.cls-2{fill:#fff;}.cls-3{fill:#3fcaea;}.cls-4{fill:#7b7cd5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.37,51.01l-43.85-24.35c-17.43-9.68-38.84,2.93-38.84,22.86v48.69c0,19.93,21.41,32.54,38.84,22.86l43.85-24.35c17.94-9.96,17.94-35.76,0-45.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m49.73,103.25H12.19s10.18-6.63,10.18-6.63c1.21-.83,1.21-2.32.17-3.32-10.73-8.85-16.14-21.99-14.8-35.57,1.98-20.14,19.35-36.16,40.35-37.33,26.25-1.46,47.81,19.73,45.5,45.12-1.89,20.8-22.15,37.73-43.86,37.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m69.79,24.65c-16.43-4.68-34.11,7.03-34.11,24.63v48.72c0,1.82.19,3.57.55,5.25h14.25c23.8,0,43.28-18.57,43.28-41.46,0-16.27-9.77-30.35-23.97-37.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m60.08,59.69h4.9l10.66,24.69h-4.9l-2.09-4.95-12.53.07c-.76,1.8-1.44,3.46-2.02,4.88h-4.9l10.87-24.69Zm7.17,16.48l-4.82-11.36c-1.37,3.15-3.17,7.34-4.9,11.36h9.72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m82.25,59.69h4.9l10.66,24.69h-4.9l-2.09-4.95-12.53.07c-.76,1.8-.98,3.46-1.55,4.88l-2.65-6.15,8.17-18.54Zm7.17,16.48l-4.82-11.36c-1.37,3.15-3.17,7.34-4.9,11.36h9.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m104.13,69.49c-3.67-.42-5.55-1.9-5.55-3.7,0-1.66,1.73-2.6,4.36-2.6,3.31,0,6.91,1.35,9.18,3.57l-.18-4.57c-1.8-1.77-5.33-2.84-9-2.84-5.4,0-9.4,2.84-9.4,7.06s3.46,6.75,9.36,7.44c4.14.48,5.94,2.01,5.94,3.91,0,2.01-1.4,3.19-4.86,3.19-2.82,0-5.49-.81-7.51-2.23l2.31,5.35c1.48.41,3.23.66,5.2.66,6.41,0,10.33-2.8,10.33-7.17s-3.89-7.34-10.19-8.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAasLogoSmall);
export default __webpack_public_path__ + "static/media/aas_logo_small.c642a6dbf3866beb338bd843e4aa0e71.svg";
export { ForwardRef as ReactComponent };